import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";

const UserResetPasswordDialog = ({ open, username, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm Password Reset</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to reset the password for <strong>{username}</strong>?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">Cancel</Button>
        <Button onClick={onConfirm} variant="contained" color="warning">
          Reset Password
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserResetPasswordDialog;
